module.exports = __webpack_public_path__ + "img/MGH-Roppongi-12-2440x1172.5da312b5.jpg";